import { ReactNode, useLayoutEffect, useState } from "react";

const DefaultPlaceholder: React.FC = () => null;

export const ClientOnly: React.FC<{
  children: ReactNode;
  placeholder?: ReactNode;
}> = ({ children, placeholder = <DefaultPlaceholder /> }) => {
  const [onBrowser, setOnBrowser] = useState(false);
  if (typeof window !== "undefined") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useLayoutEffect(() => {
      setOnBrowser(true);
    }, []);
  }
  return <>{onBrowser ? children : placeholder}</>;
};
